import * as Redux from 'react-redux'
import { Dispatch } from 'redux'

import * as shadow from '@owl-nest/shadow'
import * as api from '@owl-nest/api-client/latest'

import { likeProject, unlikeProject } from '../../../../actions/project'

export type TrackingExtraData = {
  eventAction?: string
  eventCategory?: shadow.CATEGORY
  eventLabel?: string
}

type UseProjectFollowing = () => void

type UseProjectFollowingOptions = {
  callback: () => void
  project: api.Project
  trackingExtraData?: TrackingExtraData
  userFollowsProject: boolean
}

export function useProjectFollowing({
  callback,
  project,
  trackingExtraData,
  userFollowsProject,
}: UseProjectFollowingOptions): UseProjectFollowing {
  const dispatch = Redux.useDispatch<Dispatch>()
  const tracking = shadow.useTracking()

  if (userFollowsProject) {
    return () => {
      tracking.social.track({
        ...trackingExtraData,
        socialAction: 'Unlike',
        socialNetwork: shadow.SOCIAL_NETWORK.ULULE,
        socialTarget: project.absolute_url,
      })
      dispatch(unlikeProject(project.id)).then(callback)
    }
  } else {
    return () => {
      tracking.social.track({
        ...trackingExtraData,
        socialAction: 'Like',
        socialNetwork: shadow.SOCIAL_NETWORK.ULULE,
        socialTarget: project.absolute_url,
      })
      dispatch(likeProject(project.id)).then(() => callback())
    }
  }
}
